// extracted by mini-css-extract-plugin
export default {"label":"EditTianKong_label__4Gtwk","tip":"EditTianKong_tip__Jb1AN","line":"EditTianKong_line__Yz4x4"};